export default {
  home: 'Home',
  settings: 'Settings',
  logoAlt: 'logo',
  groups: {
    prod: 'Production & Stock',
    excise: 'Excise & Compliance',
    sales: 'Sales & Finance',
    tools: 'Tools & Admin',
    wiki: 'Wiki',
  },
  menu: {
    inventory: 'Inventory',
    agp: 'AGP',
    recipes: 'Recipes',
    batches: 'Batches',
    'shopping-list': 'Shopping List',
    stock: 'Stock',
    planning: 'Planning',
    tools: 'Tools',
    invoices: 'Invoices',
    audit: 'Audit',
    suggestions: 'Suggestions',
    wiki: 'Wiki',
  },
};
